// extracted by mini-css-extract-plugin
export var fadeInOut = "_4h-3";
export var icon = "_4h-4";
export var savedIndicator = "_4h-2";
export var savingIndicator = "_4h-0";
export var spin = "_4h-1";